import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

// Generate colors dynamically based on number of categories
const generateColors = (count) => {
  const baseColors = [
    '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
    '#FF9F40', '#47B39C', '#EC6B56', '#FFC154', '#47B39C'
  ];

  if (count <= baseColors.length) {
    return baseColors.slice(0, count);
  }

  // Generate additional colors if needed
  const colors = [...baseColors];
  for (let i = baseColors.length; i < count; i++) {
    const hue = (i * 137.508) % 360; // Use golden angle approximation
    colors.push(`hsl(${hue}, 70%, 60%)`);
  }
  return colors;
};

export const CategoryPieChart = ({ categoryData = [] }) => {
    if (!categoryData.length) {
        return (
            <div className="bg-white rounded-lg p-4 shadow-sm flex items-center justify-center h-48">
                <p className="text-gray-500">No expense data available</p>
            </div>
        );
    }

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1.5,
        plugins: {
            legend: {
                position: 'right',
                labels: {
                    padding: 10,
                    font: {
                        size: 11
                    }
                }
            },
            title: {
                display: true,
                text: 'Expenses by Category',
                font: {
                    size: 14,
                    weight: 'bold'
                },
                padding: 10
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const value = context.raw;
                        return `$${value.toLocaleString()}`;
                    }
                }
            }
        }
    };

    const data = {
        labels: categoryData.map(d => d.category),
        datasets: [{
            data: categoryData.map(d => d.amount),
            backgroundColor: generateColors(categoryData.length),
            borderWidth: 2,
            borderColor: '#ffffff',
            hoverOffset: 4
        }]
    };

    return (
        <div 
            className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow duration-300"
            role="figure"
            aria-label="Pie chart showing expenses by category"
        >
            <Pie options={options} data={data} />
        </div>
    );
}; 